import { Accordion, Body1, Heading1, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { NBSP } from 'shared/constants/common';
import * as styles from './styles.css';

export const RedesignDefaultSeoText = () => {
  const deviceType = useDeviceType();
  const titleClassName = cn(deviceType === 'desktop' && styles['title']);
  const sectionClassName = cn(styles['section'], styles[deviceType]);

  return (
    <div>
      <div className={sectionClassName}>
        <div className={titleClassName}>
          <Heading1 fontWeight="700">Социальные выплаты на{NBSP}погашение ипотеки</Heading1>
        </div>
        <Accordion
          autoScrollToLastActive
          items={[
            {
              title: 'Материнский капитал',
              content: (
                <Body1 color="text-secondary-pressed">
                  С 2020 года сертификат можно получить уже после рождения первого ребёнка. Потратить средства
                  маткапитала по-прежнему можно только на определенные цели, установленные государством. Одна из них —
                  улучшение жилищных условий семьи. Средства сертификата можно использовать в качестве первоначального
                  взноса или направить на погашение уже существующего ипотечного кредита.
                </Body1>
              ),
            },
            {
              title: `Социальные выплаты для${NBSP}молодых семей`,
              content: (
                <Body1 color="text-secondary-pressed" whiteSpace="pre-line">
                  {[
                    'Молодые семьи могут получить социальную выплату для приобретения жилья или погашения ипотечного кредита.',
                    'Принять участие в программе могут семьи, в которых оба супруга моложе 36, а также одинокие родители до 35 лет включительно с несовершеннолетними детьми. Семья должна быть признана нуждающейся в улучшении жилищных условий, но при этом подтвердить достаточный доход для одобрения ипотечного кредита.',
                    'Размер выплаты составляет 30–35% от расчетной стоимости жилья.',
                  ].join('\n\n')}
                </Body1>
              ),
            },
            {
              title: `Погашение ипотеки для${NBSP}многодетных семей`,
              content: (
                <Body1 color="text-secondary-pressed" whiteSpace="pre-line">
                  {[
                    'Семьи с тремя и более детьми могут получить средства для погашения ипотеки, взятой ранее.',
                    'По условиям программы третий или последующий ребёнок должен быть рожден в период с 1 января 2019 года по 31 декабря 2030 года. А ипотечный договор — оформлен до 1 июля 2031 года на новостройку, вторичное жильё или на строительство дома.',
                    'Размер выплаты — до 450 000 рублей.',
                  ].join('\n\n')}
                </Body1>
              ),
            },
          ]}
          size={deviceType === 'desktop' ? 'L' : 'M'}
        />
      </div>
      <div className={sectionClassName}>
        <div className={titleClassName}>
          <Heading1 fontWeight="700">Об{NBSP}ипотеке</Heading1>
        </div>
        <Accordion
          autoScrollToLastActive
          items={[
            {
              title: 'Что представляет собой ипотека?',
              content: (
                <Body1 color="text-secondary-pressed">
                  Ипотека – это разновидность кредита, предоставляемого заемщику под залог его недвижимости. Право
                  собственности на купленную с использованием ипотеки квартиру остается у заёмщика, в то время как сама
                  недвижимость находится в залоге у банка-кредитора до полного погашения долга.
                </Body1>
              ),
            },
            {
              title: 'Как можно снизить процентную ставку по ипотеке?',
              content: (
                <Body1 color="text-secondary-pressed" whiteSpace="pre-line">
                  {[
                    'Существует несколько способов, которые могут помочь в снижении ипотечной ставки:',
                    'Изучить предложения банков. Некоторые из них предлагают сниженную ставку своим зарплатным клиентам, предоставляют скидки за онлайн-оформление сделок или определенные виды страховки. Иногда выгодную ставку можно купить, то есть заплатить комиссию за снижение ставки по ипотеке. На длительной дистанции такая опция может заметно снизить общую переплату по процентам.',
                    'Некоторые девелоперы также предлагают ипотеку по сниженным ставкам для квартир в новостройках, а на Циан можно найти объекты на вторичном рынке с понижением ставки на 4 процентных пункта. Такие предложения помечены специальной плашкой «Скидка на ипотеку 4%».',
                  ].join('\n\n')}
                </Body1>
              ),
            },
            {
              title: 'Стоит ли погашать ипотеку досрочно?',
              content: (
                <Body1 color="text-secondary-pressed" whiteSpace="pre-line">
                  {[
                    'Ответ на этот вопрос зависит от нескольких параметров: ставки по ипотеке, срока, финансовых возможностей заемщика.',
                    'Например, выгода от досрочного погашения зависит от того, сколько времени прошло с момента заключения ипотечного договора. Если прошло менее половины срока кредита, досрочное погашение будет целесообразным: в первые годы значительная часть платежа приходится на проценты, а досрочный платеж отправится на погашение тела кредита.',
                  ].join('\n\n')}
                </Body1>
              ),
            },
            {
              title: 'Какие типы платежей по ипотеке бывают?',
              content: (
                <Body1 color="text-secondary-pressed" whiteSpace="pre-line">
                  {[
                    'Любой кредитный платеж состоит из двух компонентов: основной суммы долга и процента за пользование заёмными средствами. При оформлении ипотеки банк может предложить два варианта платежей: аннуитетные и дифференцированные.',
                    'Размер аннуитетного платежа устанавливается на весь срок кредита — заемщик выплачивает фиксированную сумму каждый месяц. Изменяется распределение основного долга и процентов внутри этой суммы. В первое время проценты составляют большую её часть, а на погашение основного долга направляется меньшая. К окончанию срока ипотеки — наоборот.',
                    'Аннуитетный платеж удобен своей стабильностью: сумма и сроки известны заранее. Но общая переплата по процентам может быть выше, так как первое время заёмщик фактически расплачивается только по процентам, не уменьшая тело кредита.',
                    'Дифференцированный платеж формируется иначе: сумма основного долга делится на равные части на весь срок кредита, а проценты начисляются каждый месяц на остаток кредитных средств. Поэтому первые платежи могут быть значительно выше, чем при аннуитетной схеме, но чем меньше сумма долга, тем ниже размер процентов, а значит — размер общего платежа.',
                    'Такой подход помогает сократить общую сумму долга и быстрее расплатиться с кредитом, но на старте выплат по ипотеке потребуется больше средств. Это выгодно, если вы планируете досрочно погашать долг, так как в этом случае переплата банку по процентам будет ниже.',
                  ].join('\n\n')}
                </Body1>
              ),
            },
            {
              title: 'Что будет, если пропустить ежемесячный платеж?',
              content: (
                <Body1 color="text-secondary-pressed" whiteSpace="pre-line">
                  Все зависит от условий кредитного договора. В нём может быть оговорена допустимая задержка платежей по
                  кредиту на срок от одного до пяти дней. В других случаях кредитор имеет право наложить на заёмщика
                  штрафные санкции.
                </Body1>
              ),
            },
          ]}
          size={deviceType === 'desktop' ? 'L' : 'M'}
        />
      </div>
    </div>
  );
};
